import { $, $$ } from './utils.js';
import { applyLang, lang } from './i18n.js';
import { toggleTheme } from './theme.js';

/* ─── Theme & Lang toggle bindings ────── */
// lang is a live binding from i18n.js, so reading it always gives current value
function toggleLang() { applyLang(lang === 'en' ? 'nl' : 'en'); }

$('#theme-toggle').addEventListener('click', toggleTheme);
$('#lang-toggle').addEventListener('click', toggleLang);
$('#theme-toggle-mobile')?.addEventListener('click', toggleTheme);
$('#lang-toggle-mobile')?.addEventListener('click', toggleLang);

/* ─── Mobile Menu ─────────────────────── */
const hamburger = $('#nav-hamburger');
const navLinks = $('#nav-links');
hamburger.addEventListener('click', () => {
	hamburger.classList.toggle('active');
	navLinks.classList.toggle('open');
});
// Close mobile menu on link click
navLinks.querySelectorAll('a').forEach(a => {
	a.addEventListener('click', () => {
		hamburger.classList.remove('active');
		navLinks.classList.remove('open');
	});
});

/* ─── Reveal on Scroll ────────────────── */
const revealObserver = new IntersectionObserver((entries) => {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			entry.target.classList.add('visible');
			revealObserver.unobserve(entry.target);
		}
	});
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

$$('.reveal').forEach(el => revealObserver.observe(el));

/* ─── Active nav link on scroll ───────── */
const sections = $$('section[id]');
const navAnchors = $$('.nav-links a');
const visibleSections = new Set();

function updateActiveNav() {
	// Find the topmost visible section (the one closest to the viewport top)
	let best = null;
	let bestTop = Infinity;
	visibleSections.forEach(s => {
		const rect = s.getBoundingClientRect();
		// Prefer sections whose top is near the viewport top (but not past it too far)
		const score = Math.abs(rect.top);
		if (score < bestTop) {
			bestTop = score;
			best = s;
		}
	});
	if (!best) return;
	const id = best.getAttribute('id');
	navAnchors.forEach(a => {
		a.style.color = a.getAttribute('href') === '#' + id ? 'var(--primary)' : '';
	});
}

const navObserver = new IntersectionObserver((entries) => {
	entries.forEach(entry => {
		if (entry.isIntersecting) visibleSections.add(entry.target);
		else visibleSections.delete(entry.target);
	});
	updateActiveNav();
}, { threshold: [0, 0.1, 0.25, 0.5] });
sections.forEach(s => navObserver.observe(s));
window.addEventListener('scroll', updateActiveNav, { passive: true });

/* ─── Pricing toggle ──────────────────── */
const toggleMonthly = $('#toggle-monthly');
const toggleAnnual = $('#toggle-annual');
const cards = $$('.pricing-card');
if (toggleMonthly && toggleAnnual) {
	toggleMonthly.addEventListener('click', () => {
		toggleMonthly.classList.add('active');
		toggleAnnual.classList.remove('active');
		cards.forEach(c => c.classList.remove('show-annual'));
	});
	toggleAnnual.addEventListener('click', () => {
		toggleAnnual.classList.add('active');
		toggleMonthly.classList.remove('active');
		cards.forEach(c => c.classList.add('show-annual'));
	});
}
